<h5 class="commit-exchange-table table-title">{{ title }}</h5>
<div class="table-responsive table--overflow">
  <table class="commit-exchange-table table table-bordered">
    <thead>
      <tr>
        <td>CLASS/POOL</td>
        <ng-container *ngIf="isDisplayRecom">
          <td>RECOM #</td>
        </ng-container>
        <td>CUSIP</td>
        <td>CLEARING <br />INSTITUTION</td>
        <td>ORIGINAL BALANCE <br />EXCHANGED</td>
        <td>CURRENT BALANCE <br />EXCHANGED</td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of dataProvider; let j = index; trackBy: trackByIdentity">
        <td
          [ngClass]="{
            rcrBondClass: data.bondClassType === 'RCR',
            remicBondClass: data.bondClassType === 'REMIC',
          }"
        >
          {{ data?.bondClass }}
        </td>
        <ng-container *ngIf="isDisplayRecom">
          <td>{{ data?.recomNumbers }}</td>
        </ng-container>
        <td>{{ data?.cusip }}</td>
        <td>{{ data?.clearingInstitution }}</td>
        <td>{{ data?.origFace | currency: 'USD' : 'symbol' : '1.0-0' }}</td>
        <td>{{ data?.currentFace | currency: 'USD' : 'symbol' }}</td>
      </tr>
    </tbody>
  </table>
</div>
